import React from 'react';
import { CapaQuotationPartnerStrategyFile } from '@generated/graphql';
import { DialogProps } from '@routes/CompanyInfo/types';
import DetailViewDialog from './DetailViewDialog';
import { ThemeProvider, useMediaQuery, useTheme } from '@material-ui/core';
import { Close } from '@carbon/icons-react';
import { colorSet, theme as defaultTheme } from '@components/Provider';
import { MediaSwiperMobile } from './MediaSwiper/MediaSwiperMobile';

interface PartnerFilesDetailViewProps extends DialogProps {
  files?: CapaQuotationPartnerStrategyFile[];
  target?: number;
}

const PartnerFilesDetailView: React.FunctionComponent<PartnerFilesDetailViewProps> = ({
  open,
  onClose,
  files = [],
  target
}) => {
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up(1200));

  if (!isDesktop) {
    return (
      <ThemeProvider theme={defaultTheme}>
        <DetailViewDialog
          isOpen={open}
          onClose={onClose}
          closeIcon={<Close size={24} color={colorSet.gray900} />}
        >
          <MediaSwiperMobile
            files={files}
            initialSlide={target ?? 0}
            isOne={files.length === 1}
          />
        </DetailViewDialog>
      </ThemeProvider>
    );
  } else {
    return (
      <ThemeProvider theme={defaultTheme}>
        <DetailViewDialog isOpen={open} onClose={onClose} maxWidth={828}>
          <DetailViewDialog.MediaSwiper
            initialSlide={target ?? 0}
            backgroundColor="white"
            files={files}
            width="100%"
          />
        </DetailViewDialog>
      </ThemeProvider>
    );
  }
};

export default PartnerFilesDetailView;
